import { Form, Row, Col, Input } from 'antd'
import UploadDocument from 'components/global/UploadDocument'
import React, { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import { PickUpDetailsType } from 'types/event/eventAttendance'

const SomeOneElse = ({
  formValues,
  setFormValues,
}: {
  formValues: PickUpDetailsType
  setFormValues: React.Dispatch<React.SetStateAction<PickUpDetailsType>>
}) => {
  const [documentIds, setDocumentIds] = useState<string[]>([])

  useEffect(() => {
    if (documentIds.length) {
      setFormValues({
        ...formValues,
        photoId: documentIds[0],
      })
    }
  }, [documentIds])

  return (
    <>
      <Row className="mt-20px">
        <Col>
          <label className="input-label required-input">FirstName</label>
          <Input
            name="name"
            className="custom-input-field w-full"
            placeholder="Name"
            onChange={e =>
              setFormValues({ ...formValues, name: e.target.value })
            }
          />
        </Col>
      </Row>
      <Row className="mt-20px">
        <Col>
          <label className="input-label">Email</label>
          <Input
            name="email"
            className="custom-input-field w-full"
            placeholder="Email@gmail.com"
            onChange={e =>
              setFormValues({
                ...formValues,
                email: e.target.value,
              })
            }
          />
        </Col>
      </Row>
      <Row className="mt-20px">
        <Col>
          <label className="input-label required-input">Phone number</label>
          <div className="phone-number-form">
            <PhoneInput
              country={formValues.phone?.isoCode || 'us'}
              onChange={(value: string, data: any) => {
                setFormValues({
                  ...formValues,
                  phone: {
                    dialCode: '+' + data.dialCode,
                    number: '+' + value,
                    isoCode: data.countryCode.toUpperCase(),
                  },
                })
              }}
            />
          </div>
        </Col>
      </Row>
      <Row className="mt-20px">
        <Col>
          <label className="input-label">Make a picture</label>
        </Col>
        <Col span={16}>
          <UploadDocument
            documentIds={documentIds}
            setDocumentIds={setDocumentIds}
            docType="image/*"
          />
        </Col>
      </Row>
    </>
  )
}

export default SomeOneElse
